<gen-dynamic-form-table
  [formId]="payload.formId"
  [listenToDataChange]="payload.listenToDataChange"
  [tableTitle]="payload.tableTitle"
  [data]="formData || []"
  [formVertical]="payload.formVertical"
  [popupMode]="payload.popupMode"
  [disabled]="payload.disabled || disabled"
  [editMode]="payload.editMode"
  [viewAsTable]="payload?.viewAsTable"
  [tableVertical]="payload?.tableVertical"
  [titleClass]="payload?.tableTitleCssClass"
  [validationStatusRef]="validationStatusRef"
  [showAddButton]="payload.showAddButton"
  [itemAddRef]="addHandler.bind(this)"
  [showDeleteButton]="payload.showDeleteButton"
  (itemDeletedEmitter)="deleteItemHanlder($event)"
  [itemNgClassRef]="getItemNgClass.bind(this)"
  (itemAddEmitter)="handleAddEvent($event)"
  (itemUpdateEmitter)="handleUpdateEvent($event)"
  (initEmitter)="initChange = $event"
  [customizeRowClassConfig]="payload.customizeRowClassConfig"
  [availableCustomClassBasedOn]="payload.availableCustomClassBasedOn"
  [hideTitles]="payload.hideTitles || false">
</gen-dynamic-form-table>
